import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as R from 'ramda';
import $ from 'jquery';

import { useDispatch } from 'react-redux';
import parsePhoneNumber from 'libphonenumber-js';

import { CloseProfile } from './../../_common/closeProfile';
import { DonnesProfile } from './../../_common/donnesProfile';
import { PaySummary } from '../../_common/paySummary';

import Emptylustration from './../../../assets/images/svg/057-contract-1.svg';
import { fetchInvoices, resetPassword } from '../../../actions/partner/partner';
import { RegleModal } from '../../_common/regleModal';
import InvoicePartner from '../../../constants/models/invoicePartner';
import AnticipaHeader from './header';
import AnticipaFilter from './filter';
import { LoadingState } from '../../../_common/loadingState';
import * as Loadings from '../../../constants/loadings/partner/partner';




export const AnticipaMain = ({ users, partnerState, routerQuery, pageSearch, setPageSearch, date, setDate, isLoadingRepresentatives, etablissement, partner, isPartner }) => {
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));

    const dispatch = useDispatch();

    //const filterOptions = { all: 'tous', notAccepted: "n'a pas accepté", ongoing: 'en cours', finished: 'complété', yearAndMore: "plus d'un an" };
    const queryStatus = { AnticipaNotAccepted: "n'a pas accepté", AnticipaOngoing: "en cours", AnticipaFinished: "complété", AnticipaYearAndMore: "contrat d'un an", AnticipaClosed: "clôture" };
    const statusOptions = { notAccepted: "n'a pas accepté", ongoing: "en cours", finished: "complété", yearAndMore: "contrat d'un an", closed: "clôture" };

    const [usersToDisplay, setUsersToDisplay] = useState(users);
    const [selectedUser, setSelectedUser] = useState({ email: "", phoneNumber: "", countryCode: "", recipientEmail: "" });
    const [selectedUserCopy, setSelectedUserCopy] = useState({});
    const [invoices, setInvoices] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
    }, []);


    async function handleGetInvoices(userId) {
        setIsLoading(true);

        try {
            let invoicesData = await fetchInvoices(userId);
            invoicesData = invoicesData.items.map(i => new InvoicePartner(i));

            setIsLoading(false);
            setInvoices(invoicesData);
        } catch (error) {
            setIsLoading(false);
        }

    }



    return (
        <article className="view-calc pt-6 mb-auto">
            <div className="container-fluid">
                <AnticipaHeader users={users} statusOptions={statusOptions} partnerState={partnerState} isPartner={isPartner} />
                <AnticipaFilter routerQuery={routerQuery} queryStatus={queryStatus} pageSearch={pageSearch} setPageSearch={setPageSearch} date={date} setDate={setDate} statusOptions={statusOptions} />
            </div >
            <div className="auto-view h-100 mb-auto">
                <div className="container-fluid h-inherit flex-column">
                    {
                        isLoadingRepresentatives || partnerState.isLoading.includes(Loadings.FETCHING_USERS) ?
                            <LoadingState /> :
                            <>
                                {!R.isEmpty(users) ?
                                    <section className="grid grid-sm-min grid-lg-narrow grid-xl-4 pb-sm">
                                        <h1 className="sr-only visually-hidden">Anticipa Users</h1>
                                        {users.map((user, index) => {
                                            let phone = R.isNil(user.phoneNumber) ? null : parsePhoneNumber(user.phoneNumber);
                                            const userEtablissement = isPartner ? partnerState.etablissementList.items.find(i => i.id === user.etablissementId) : null;
                                            return (
																							<div key={index} className="card text-center shadow h-100 rounded border-0">
																								<div className="card-header alin-items-center px-2 py-1">
																									<button
																										className="btn btn-icon btn-stage-secondary rounded-max p-2 mx-1"
																										data-toggle="modal"
																										data-target="#DonnesProfile"
																										onClick={() => {
																											setSelectedUser({ ...user, countryCode: R.isNil(phone) ? "33" : parseInt(phone.countryCallingCode), phoneCountry: R.isNil(phone) ? "" : phone.country, email: user.email, recipientEmail: user.recipientEmail });
																											setSelectedUserCopy(user);
																										}}>
																										<i
																											className="eva fs-sm eva-person-outline"
																											data-toggle="tooltip"
																											data-placement="top"
																											data-template='<div className="tooltip tooltip-secondary" role="tooltip"><div className="arrow"></div><div className="tooltip-inner px-3 py-2 rounded font-weight-regular lh-root"></div></div>'
																											title="Données personnelles"></i>
																									</button>
																									<button className="btn btn-icon btn-stage-warning rounded-max p-2 mx-1 shadow-none" onClick={(e) => dispatch(resetPassword(user.email, user.phoneNumber))}>
																										<i
																											className="eva fs-sm eva-email-outline"
																											data-toggle="tooltip"
																											data-placement="top"
																											data-template='<div className="tooltip tooltip-white-warning" role="tooltip"><div className="arrow"></div><div className="tooltip-inner px-3 py-2"></div></div>'
																											title="Envoyer un e-mail de récupération"></i>
																									</button>
																									<button
																										className="btn btn-icon btn-stage-info rounded-max p-2 mx-1 shadow-none"
																										data-toggle="modal"
																										data-target="#paySummary"
																										onClick={(e) => {
																											handleGetInvoices(user.id);
																											setSelectedUser({ ...user });
																										}}>
																										<i
																											className="eva fs-sm eva-credit-card-outline"
																											data-toggle="tooltip"
																											data-placement="top"
																											data-template='<div className="tooltip tooltip-white-info" role="tooltip"><div className="arrow"></div><div className="tooltip-inner px-3 py-2"></div></div>'
																											title="Voir Paiements"></i>
																									</button>
																								</div>
																								<hr className="my-0" />
																								<div className="card-body my-auto px-3">
																									<h4 className="h3 text-capitalize ls-n1 font-weight-black mt-auto mb-2">
																										{user.firstName + " " + user.lastName}
																										{user.hasHrDocuments ? <span className="badge fs-1 bg-info text-white lj-1 px-2 py-1 align-middle ml-1">RH</span> : ""} {user.aidavieId ? <span className="badge fs-1 bg-info text-white lj-1 px-2 py-1 align-middle ml-1">Aidavie</span> : ""}
																									</h4>
																									<p className="fs-3 text-uppercase lh-copy o-40 font-weight-bolder mb-0">{!R.isNil(user.mainRepresentative) ? user.mainRepresentative.firstName + " " + user.mainRepresentative.lastName : ""}</p>
																									<div className={"progress position-relative mb-auto w-100 text-center h-4 rounded-max align-items-center mt-3" + (statusOptions[user.status] === statusOptions.oneYearContract ? " bg-none" : " bg-dim")}>
																										<div
																											className={"progress-bar h-100 rounded-inherit" + (statusOptions[user.status] === statusOptions.ongoing ? " bg-secondary o-20" : statusOptions[user.status] === statusOptions.finished ? " bg-primary o-20" : "")}
																											style={{ width: `${statusOptions[user.status] === statusOptions.notAccepted ? "0" : statusOptions[user.status] === statusOptions.ongoing ? "50" : "100"}%` }}
																											role="progressbar"></div>
																										<div
																											className={
																												"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder h6 my-auto text-uppercase lh-solid" +
																												(statusOptions[user.status] === statusOptions.ongoing ? " text-secondary" : statusOptions[user.status] === statusOptions.notAccepted ? "" : statusOptions[user.status] === statusOptions.yearAndMore ? " text-white" : " text-primary")
																											}
																											role="progressbar">
																											{statusOptions[user.status]}
																										</div>
																									</div>

																									<p className="fs-2 mt-2 lh-copy o-40 font-weight-bolder mb-0">{new Intl.DateTimeFormat("fr-FR").format(user.creationDate)}</p>
																								</div>

																								{/* <hr className="my-0" /> */}
																								<div className="alin-items-center pt-0">
																									<button className="btn btn-info" data-toggle="modal" data-target="#closeProfile" onClick={() => setSelectedUser(user)}>
																										Clôture du dossier
																									</button>
																									<hr className="my-0 o-0" />
																									{user.hasPendingInvoice ? (
																										<button className="btn btn-stage-success shadow-none px-3 py-2 mt-1 fs-2" data-toggle="modal" data-target="#regleModal" onClick={() => setSelectedUser(user)}>
																											<i className="eva fs-sm eva-checkmark-circle-outline align-middle text-success"></i>
																											<span className="align-middle mx-2">Règlement actualisation</span>
																										</button>
																									) : (
																										""
																									)}
																								</div>
																								{isPartner ? (
																									<div className="card-footer flex-row fs-2 mx-auto mb-auto mt-3 justify-content-center w-100 font-weight-bolder py-1 bg-light rounded-bottom">
																										<span className="o-60">Etablissement: </span>
																										<span className="text-uppercase mx-1">{userEtablissement.name}</span>
																									</div>
																								) : (
																									""
																								)}
																							</div>
																						);
                                        })}
                                    </section>
                                    :
                                    <section className="block text-center m-auto py-xs">
                                        <img className="img-fluid img-contain container-paper mx-auto mt-auto mb-3" src={Emptylustration} width={70} alt="Assist@" />
                                        <div className="block text-center container-thin mx-auto mb-auto">
                                            <h1 className="h1 font-weight-semi ls-n2 lh-1">Aucun dossier</h1>
                                            <p className="fs-aux o-80 mb-0">S'il vous plaît voir un autre état.</p>
                                        </div>
                                    </section>
                                }
                            </>
                    }
                </div>
            </div>
            <div className="container-fluid">
                <nav className="flex-row my-3 justify-content-center" aria-label="Page navigation">
                    {partnerState.currentPage > 1 ? <Link to={`/partner/anticipa?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${routerQuery.type !== "" ? "&type=" + routerQuery.type : ""}${routerQuery.startDate !== "" ? "&startDate=" + routerQuery.startDate : ""}${routerQuery.endDate !== "" ? "&endDate=" + routerQuery.endDate : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "" ? "" : routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-left-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-left-outline fs-2"></i></button>}
                    {partnerState.currentPage > 1 ? <Link to={`/partner/anticipa?page=${partnerState.currentPage - 1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${routerQuery.type !== "" ? "&type=" + routerQuery.type : ""}${routerQuery.startDate !== "" ? "&startDate=" + routerQuery.startDate : ""}${routerQuery.endDate !== "" ? "&endDate=" + routerQuery.endDate : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "" ? "" : routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-back-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-back-outline fs-2"></i></button>}

                    <span className="btn rounded-sm bg-dim px-2 py-1 mx-1 d-flex justify-content-center align-items-center fs-aux">{partnerState.currentPage} de {partnerState.totalPages}</span>

                    {partnerState.currentPage < partnerState.totalPages ? <Link to={`/partner/anticipa?page=${partnerState.currentPage + 1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${routerQuery.type !== "" ? "&type=" + routerQuery.type : ""}${routerQuery.startDate !== "" ? "&startDate=" + routerQuery.startDate : ""}${routerQuery.endDate !== "" ? "&endDate=" + routerQuery.endDate : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "" ? "" : routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-forward-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-forward-outline fs-2"></i></button>}
                    {partnerState.currentPage < partnerState.totalPages ? <Link to={`/partner/anticipa?page=${partnerState.totalPages}${pageSearch !== "" ? "&search=" + pageSearch : ""}${routerQuery.type !== "" ? "&type=" + routerQuery.type : ""}${routerQuery.startDate !== "" ? "&startDate=" + routerQuery.startDate : ""}${routerQuery.endDate !== "" ? "&endDate=" + routerQuery.endDate : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "" ? "" : routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-right-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-right-outline fs-2"></i></button>}
                </nav>
            </div>
            <DonnesProfile selectedProfile={selectedUser} setSelectedProfile={setSelectedUser} selectProfileCopy={selectedUserCopy} />
            <CloseProfile user={selectedUser} />
            <PaySummary invoices={invoices} user={selectedUser} etablissement={etablissement} partner={partner} />
            <RegleModal selectedUser={selectedUser} />
        </article >
    );
};
